import React from 'react'
import styled from 'styled-components'
import { Input } from 'reactstrap'

const Container = styled.div`
  position: relative;
`
const Error = styled.div`
  padding-bottom: 15px;
  color: red;
  font-size: 11px;
  position: absolute;
  left: 0;
`

const InputBox = props => {
  return (
    <Container>
      <Input {...props} />
      <Error>{props.error ? props.error : ''}</Error>
    </Container>
  )
}

export default InputBox
